<template>
  <div style="position: relative;">
      <el-card class="box-card">
        <div class="header-login">{{ $t('login.title') }}</div>
        <el-input :placeholder="$t('login.username')" v-model="username" @keypress.native.enter="login" class="input-login"></el-input>
        <el-input :placeholder="$t('login.password')" v-model="password" @keypress.native.enter="login" class="input-login" type="password" style="margin-top: 20px;"></el-input>
        <el-input :placeholder="$t('login.verify_code')" v-model="code" @keypress.native.enter="login" class="input-login" style="margin-top: 20px; background: none;">
          <!-- <template slot="prepend"><i class="el-icon-view"></i></template> -->
          <template slot="append">
            <verify-code :identifyCode="verify_code" @getCode="getCode()" style="position: absolute; right: 0; top: 0;"></verify-code>
          </template>
        </el-input>
        <!-- <el-input placeholder="请输入密码" v-model="password" show-password></el-input> -->
        <div class="login-btn" @click="login" v-text="$t('login.btn')"></div>
        <!-- <el-button type="primary" plain @click="login" style="width: 100%; margin-top: 20px;">登录</el-button> -->
      </el-card>

      <div class="change-languare">
        <el-select v-model="languare" placeholder="请选择" size="mini" class="input-login" style="width: 100px; position: absolute; z-index: 999999; right: 10px;">
          <el-option label="中文" value="CN"></el-option>
          <el-option label="英文" value="EN"></el-option>
        </el-select>
      </div>

      <div data-v-760fba50="">
          <div class="header-bg" data-v-760fba50="">
              <div class="header-inner header-inner-bg" data-v-760fba50=""></div>
          </div>
          <header data-v-760fba50="">
              <div class="container" data-v-760fba50="">
                  <div data-v-760fba50="">
                      <div data-v-760fba50="">
                          <img src="../../assets/login/2539b65.svg" style="transform: translateY(0px)" data-v-760fba50="" />
                      </div>
                  </div>
                  <!--<div class="operation-wrapper" data-v-760fba50="">-->
                      <!--<a href="tel: 400-601-0918" class="telephone" data-v-760fba50="">400-601-0918</a>-->
                      <!--<div class="btn glowbtn small" data-v-4373a0dd="" data-v-760fba50="">-->
                          <!--<div class="glowbtn__glow" style="transform: translate(1px, 28px);" data-v-4373a0dd=""></div>-->
                          <!--<div class="glowbtn__text" data-v-4373a0dd="">-->
                              <!--立即体验-->
                          <!--</div>-->
                      <!--</div>-->
                  <!--</div>-->
              </div>
          </header>
      </div>
      <div class="resource-page">
          <div class="resource-info" data-v-0748bb76="">
              <div class="header-info" data-v-0748bb76="">
                  <img src="../../assets/login/b7d092d.jpg" alt="tiktok-TopBuzz-BuzzVideo" class="header-info-bg" data-v-0748bb76="" />
                  <div class="header-info-info container" data-v-0748bb76="">
                      <h1 class="title" data-v-0748bb76="" v-text="$t('login.header_title')"></h1>
                      <p class="desc" data-v-0748bb76="" v-text="$t('login.header_content')"></p>
                      <div class="glowbtn" data-v-4373a0dd="" data-v-0748bb76="">
                          <div class="glowbtn__glow" style="transform:translate(0, 0);" data-v-4373a0dd=""></div>
                          <div class="glowbtn__text" data-v-4373a0dd="" v-text="$t('login.header_desc')"></div>
                      </div>
                  </div>
              </div>
              <div class="resource-info-detail" style="background:linear-gradient(342.96deg, #030303 0%, #373737 98.33%, #373737 98.33%);" data-v-dc683b5e="" data-v-0748bb76="">
                  <div class="detail container" data-v-dc683b5e="">
                      <div class="phone" data-v-dc683b5e="">
                          <div class="phone-shadow" data-v-dc683b5e=""></div>
                          <!--<div class="switch-btn left" data-v-dc683b5e="">-->
                              <!--<div data-v-dc683b5e="">-->
                                  <!--<span class="iconfont icon-left" data-v-dc683b5e=""></span>-->
                              <!--</div>-->
                          <!--</div>-->
                          <!--<div class="switch-btn right" data-v-dc683b5e="">-->
                              <!--<div data-v-dc683b5e="">-->
                                  <!--<span class="iconfont icon-right" data-v-dc683b5e=""></span>-->
                              <!--</div>-->
                          <!--</div>-->
                          <div class="phone-content" data-v-dc683b5e="">
                              <img src="../../assets/login/ab138ab.jpg" class="last" data-v-dc683b5e="" />
                              <!---->
                          </div>
                          <img src="../../assets/login/4fec756.png" class="phone-border" data-v-dc683b5e="" />
                          <div class="phone-content-deco-wrapper" data-v-dc683b5e="">
                              <video data-v-dc683b5e="" src="../../assets/login/b2aa02f.mp4" preload="auto" loop="loop" muted="muted" autoplay="autoplay" class="phone-content-deco video-deco"></video>
                          </div>

                      </div>
                      <div class="os-info" data-v-16d96512="" data-v-dc683b5e="">
                          <div class="tabs" data-v-16d96512="">
                              <div data-v-b6b351da="" data-v-16d96512="" class="switch-indicator">
                                  <div data-v-b6b351da="" class="switch-indicator-content">
                                      <div data-v-16d96512="" data-v-b6b351da="" class="tab-item active">
                                          <img data-v-16d96512="" data-v-b6b351da="" src="../../assets/login/ef7bf8e.png" class="tab-item-img" />
                                      </div>
                                      <!--<div data-v-16d96512="" data-v-b6b351da="" class="tab-item">-->
                                          <!--<img data-v-16d96512="" data-v-b6b351da="" src="../../assets/login/e2fee6a.png" class="tab-item-img" />-->
                                          <!--<span data-v-16d96512="" data-v-b6b351da="">&amp;</span>-->
                                          <!--<img data-v-16d96512="" data-v-b6b351da="" src="../../assets/login/3f6470f.png" class="tab-item-img" />-->
                                      <!--</div>-->
                                  </div>
                                  <div data-v-b6b351da="" class="indicator" style="width: 250px; transform: translateX(0px);"></div>
                              </div>
                          </div>
                          <div data-v-80480774="" data-v-16d96512="" class="fade-switch" style="transition-duration: 400ms; left: 0px; opacity: 1;">
                              <div data-v-16d96512="" data-v-80480774="" class="info-desc">
                                  <div data-v-16d96512="" data-v-80480774="" class="info-desc-item">
                                      <img data-v-16d96512="" data-v-80480774="" src="../../assets/login/7dd7142.svg" class="icon" />
                                      <div data-v-16d96512="" data-v-80480774="" class="title" v-text="$t('login.item1_title')"></div>
                                      <div data-v-16d96512="" data-v-80480774="" class="desc" v-html="$t('login.item1_content')"></div>
                                  </div>
                                  <div data-v-16d96512="" data-v-80480774="" class="info-desc-item">
                                      <img data-v-16d96512="" data-v-80480774="" src="../../assets/login/be27638.svg" class="icon" />
                                      <div data-v-16d96512="" data-v-80480774="" class="title" v-text="$t('login.item2_title')"></div>
                                      <div data-v-16d96512="" data-v-80480774="" class="desc" v-html="$t('login.item2_content')"></div>
                                  </div>
                                  <div data-v-16d96512="" data-v-80480774="" class="info-desc-item">
                                      <img data-v-16d96512="" data-v-80480774="" src="../../assets/login/58b66e7.svg" class="icon" />
                                      <div data-v-16d96512="" data-v-80480774="" class="title" v-text="$t('login.item3_title')"></div>
                                      <div data-v-16d96512="" data-v-80480774="" class="desc" v-html="$t('login.item3_content')"></div>
                                  </div>
                                  <div data-v-16d96512="" data-v-80480774="" class="info-desc-item">
                                      <img data-v-16d96512="" data-v-80480774="" src="../../assets/login/127b66d.svg" class="icon" />
                                      <div data-v-16d96512="" data-v-80480774="" class="title" v-text="$t('login.item4_title')"></div>
                                      <div data-v-16d96512="" data-v-80480774="" class="desc" v-html="$t('login.item4_content')"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <footer data-v-3ff44a83="">
          <div class="footer-container" data-v-3ff44a83=""></div>
          <div class="copy-right" data-v-3ff44a83="">
              <div style="margin-bottom: 8px;" data-v-3ff44a83="">
                  网络文化许可证-京网文-（2016）6603-897号
                  <span style="margin-left: 16px" data-v-3ff44a83="">经营许可证编号：京B2-20161623</span>
              </div>
              <a href="https://beian.miit.gov.cn/" style="text-decoration: none;" target="_blank" data-v-3ff44a83=""> &copy; 2020 巨量引擎 粤ICP备19065723号-1&nbsp;&nbsp;&nbsp;&nbsp; </a>
              <span data-v-3ff44a83="" class=""> 法律声明 </span>
              <span class="license" data-v-3ff44a83=""> 营业执照 </span>北京巨量引擎网络技术有限公司
              <div style="width:300px;margin:0 auto; padding:20px 0;" data-v-3ff44a83="">
                  <img src="../../assets/login/b95aa35.png" alt="" style="width: 20px;height:20px" data-v-3ff44a83="" />
                  <a href="javascript:;" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;" data-v-3ff44a83=""> <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;" data-v-3ff44a83="">京公网安备 11010202021672号</p></a>
              </div>
          </div>
      </footer>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      checked: true,
      username: '',
      password: '',
      code: '',
      verify_code: '',
      languare: 'CN'
    };
  },
  created() {
    this.languare = 'EN';
    const lang = localStorage.lang || 'en';
    this.languare = lang === 'en' ? 'EN' : 'CN';
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = '/';
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    login(formName) {
      if (this.username === '') {
        this.$message.error(this.$t('login.username_verify'));
        return false;
      }
      if (this.password === '') {
        this.$message.error(this.$t('login.password_verify'));
        return false;
      }
      if (this.code === '') {
        this.$message.error(this.$t('login.code_null'));
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.$message.error(this.$t('login.code_verify'));
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    }
  },
  watch: {
    'languare'(val) {
      this.$i18n.locale = val === 'EN' ? 'en' : 'cn';
      localStorage.setItem('lang', val === 'EN' ? 'en' : 'cn');
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) }
};
</script>
<style lang="less">
  .box-card {
    position: absolute;
    z-index: 9999;
    width: 280px;
    height: 320px;
    top: 100px;
    right: 120px;
    border-radius: 15px;
    background: rgba(0, 0, 0, .4);
    border: none;
    .header-login {
      width: 100%;
      height: 60px;
      color: #D3D7F7;
      font-size: 20px;
    }
    .login-btn {
      width: 100%;
      height: 40px;
      margin-top: 20px;
      border: 1px solid #D3D7F7;
      border-radius: 5px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #D3D7F7;
      cursor: pointer;
    }
  }
  .change-languare {
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 9999;
  }
  .el-input__inner {
    background: none;
  }
  .el-radio-button--mini .el-radio-button__inner {
    padding: 4px 5px;
    font-size: 12px;
  }
  body {
      margin: 0;
      padding: 0;
      border: 0;    -webkit-text-size-adjust: none;
      -webkit-tap-highlight-color: rgba(0,0,0,0)
  }

  strong {
      font-weight: 700
  }

  body,html {
      font-family: PingFangSC,helvetica neue,hiragino sans gb,arial,microsoft yahei ui,microsoft yahei,simsun,sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      scroll-behavior: smooth
  }

  body {
      min-width: 1264px
  }

  .container {
      width: 1264px;
      margin: 0 auto;
      padding: 0 32px;
      box-sizing: border-box
  }

  header[data-v-760fba50] {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 64px;
      font-size: 0;
      background: transparent;
      z-index: 20;
      transition: background .2s ease-in-out;
      min-width: 1264px
  }

  header .container[data-v-760fba50] {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      padding: 0 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(0, 0, 0, .2);
  }

  header .container .logo-wrapper[data-v-760fba50] {
      margin-right: 48px;
      width: 104px;
      height: 29px;
      display: inline-block
  }

  header .container .logo-wrapper img[data-v-760fba50] {
      transform: translateY(10px)
  }

  footer[data-v-3ff44a83] {
      position: relative;
      color: #fff;
      font-size: 14px;
      background: #111;
      overflow: hidden
  }

  footer .footer-container[data-v-3ff44a83] {
      display: flex;
      justify-content: center
  }

  footer .copy-right[data-v-3ff44a83] {
      width: 100%;
      background: #000;
      text-align: center;
      padding: 22px 0;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      opacity: .35;
      line-height: 20px
  }

  footer .copy-right a[data-v-3ff44a83] {
      color: #fff
  }

  footer .copy-right .license[data-v-3ff44a83] {
      margin: 0 10px
  }

  .os-info[data-v-16d96512] {
      width: 690px
  }

  .os-info .tabs[data-v-16d96512] {
      padding-top: 48px;
      border-bottom: 1px solid hsla(0,0%,100%,.4);
      width: 100%;
      position: relative
  }

  .os-info .tabs[data-v-16d96512] .indicator {
      height: 2px;
      border-bottom: 2px solid #fff;
      position: absolute;
      bottom: 0
  }

  .os-info .tabs .tab-item[data-v-16d96512] {
      padding: 23px 0 24px;
      cursor: pointer;
      font-size: 18px;
      line-height: 24px;
      color: hsla(0,0%,100%,.6);
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px solid transparent
  }

  .os-info .tabs .tab-item[data-v-16d96512]:first-child {
      width: 250px
  }

  .os-info .tabs .tab-item[data-v-16d96512]:nth-child(2) {
      width: 440px
  }

  .os-info .tabs .tab-item[data-v-16d96512]:hover {
      background: hsla(0,0%,100%,.05)
  }

  .os-info .tabs .tab-item.active[data-v-16d96512] {
      transition: all .2s
  }

  .os-info .tabs .tab-item .tab-item-img[data-v-16d96512] {
      height: 26px
  }

  .os-info .tabs .tab-item span[data-v-16d96512] {
      margin: 0 12px
  }

  .os-info .info-desc[data-v-16d96512] {
      display: flex;
      flex-wrap: wrap
  }

  .os-info .info-desc .info-desc-item[data-v-16d96512] {
      width: 345px;
      padding: 60px 0 8px 32px;
      box-sizing: border-box
  }

  .os-info .info-desc .info-desc-item .icon[data-v-16d96512] {
      width: 60px;
      height: 60px;
      margin-bottom: 24px
  }

  .os-info .info-desc .info-desc-item .title[data-v-16d96512] {
      margin-bottom: 10px;
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      color: #fff
  }

  .os-info .info-desc .info-desc-item .desc[data-v-16d96512] {
      color: #999;
      font-size: 16px;
      line-height: 28px
  }

  .resource-info-detail[data-v-dc683b5e] {
      height: 1008px;
      display: flex;
      align-items: center;
      overflow: hidden
  }

  .resource-info-detail .detail[data-v-dc683b5e] {
      height: 640px;
      display: flex
  }

  .resource-info-detail .phone[data-v-dc683b5e] {
      width: 510px;
      height: 1008px;
      position: relative
  }

  .resource-info-detail .phone .phone-shadow[data-v-dc683b5e] {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(../../assets/login/66a154a.png) 0 0/508px 794px no-repeat;
      mix-blend-mode: multiply
  }

  .resource-info-detail .phone .phone-border[data-v-dc683b5e] {
      position: absolute;
      left: 7.8px;
      top: 5.8px;
      width: 305.5px;
      height: 633.4px
  }

  .resource-info-detail .phone .phone-content[data-v-dc683b5e] {
      position: absolute;
      top: 21px;
      left: 21.8px;
      width: 277px;
      height: 601px;
      overflow: hidden
  }

  .resource-info-detail .phone .phone-content>img[data-v-dc683b5e] {
      width: 100%;
      height: auto;
      position: absolute;
      left: 0;
      top: 0
  }

  .resource-info-detail .phone .phone-content .current[data-v-dc683b5e] {
      -webkit-animation: fade-data-v-dc683b5e .3s ease-in-out;
      animation: fade-data-v-dc683b5e .3s ease-in-out
  }

  .resource-info-detail .phone .switch-btn[data-v-dc683b5e] {
      width: 64px;
      height: 633.4px;
      position: absolute;
      top: 0;
      padding-top: 283px;
      transition: background .2s;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none
  }

  .resource-info-detail .phone .switch-btn .iconfont[data-v-dc683b5e] {
      color: #fff;
      font-size: 14px;
      font-weight: 700
  }

  .resource-info-detail .phone .switch-btn:hover>div[data-v-dc683b5e] {
      background: hsla(0,0%,100%,.15)
  }

  .resource-info-detail .phone .switch-btn:active>div[data-v-dc683b5e] {
      background: hsla(0,0%,100%,.2)
  }

  .resource-info-detail .phone .switch-btn>div[data-v-dc683b5e] {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: hsla(0,0%,100%,.08);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer
  }

  .resource-info-detail .phone .switch-btn>div img[data-v-dc683b5e] {
      width: 6px;
      height: 12px
  }

  .resource-info-detail .phone .switch-btn.left[data-v-dc683b5e] {
      left: -112px
  }

  .resource-info-detail .phone .switch-btn.right[data-v-dc683b5e] {
      right: 76px
  }

  .resource-info-detail .info[data-v-dc683b5e] {
      width: 690px
  }

  .resource-info-detail .info.dongchedi-wrapper .tabs[data-v-dc683b5e],.resource-info-detail .info.faceu-wrapper .tabs[data-v-dc683b5e],.resource-info-detail .info.qingyan-wrapper .tabs[data-v-dc683b5e] {
      border-bottom: 1px solid rgba(51,51,51,.4)!important
  }

  .resource-info-detail .info.dongchedi-wrapper .tabs .tab-item[data-v-dc683b5e],.resource-info-detail .info.faceu-wrapper .tabs .tab-item[data-v-dc683b5e],.resource-info-detail .info.qingyan-wrapper .tabs .tab-item[data-v-dc683b5e] {
      color: #333
  }

  .resource-info-detail .info.dongchedi-wrapper .tabs[data-v-dc683b5e] .indicator,.resource-info-detail .info.faceu-wrapper .tabs[data-v-dc683b5e] .indicator,.resource-info-detail .info.qingyan-wrapper .tabs[data-v-dc683b5e] .indicator {
      border-bottom: 2px solid #333
  }

  .resource-info-detail .info.dongchedi-wrapper .info-desc .info-desc-text .content[data-v-dc683b5e],.resource-info-detail .info.faceu-wrapper .info-desc .info-desc-text .content[data-v-dc683b5e],.resource-info-detail .info.qingyan-wrapper .info-desc .info-desc-text .content[data-v-dc683b5e] {
      color: #333
  }

  .resource-info-detail .info.douyin-wrapper .action span[data-v-dc683b5e],.resource-info-detail .info.douyin-wrapper .tab-item[data-v-dc683b5e]:hover {
      color: #5784ff!important
  }

  .resource-info-detail .info .tabs[data-v-dc683b5e] {
      padding-top: 46px;
      border-bottom: 1px solid hsla(0,0%,100%,.4);
      width: 100%;
      position: relative
  }

  .resource-info-detail .info .tabs[data-v-dc683b5e] .indicator {
      height: 2px;
      border-bottom: 2px solid #fff;
      position: absolute;
      bottom: 0
  }

  .resource-info-detail .info .tabs .tab-item[data-v-dc683b5e] {
      color: #fff;
      font-size: 22px;
      line-height: 24px;
      text-align: center;
      transition: background .2s;
      cursor: pointer;
      padding: 24px 0 25px;
      flex: 1
  }

  .resource-info-detail .info .tabs .tab-item[data-v-dc683b5e]:hover {
      color: #0548ff
  }

  .resource-info-detail .info .tabs .tab-item.active[data-v-dc683b5e] {
      font-weight: 700;
      transition: all .2s
  }

  .resource-info-detail .info .info-desc[data-v-dc683b5e] {
      height: 373px;
      display: flex;
      flex-direction: column
  }

  .resource-info-detail .info .info-desc .fade-switch-item[data-v-dc683b5e]:first-child {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center
  }

  .resource-info-detail .info .info-desc .info-desc-text .content[data-v-dc683b5e] {
      color: #fff;
      font-size: 18px;
      line-height: 32px
  }

  .resource-info-detail .info .info-desc .info-desc-text .action[data-v-dc683b5e] {
      display: flex;
      align-items: center;
      margin-top: 10px;
      cursor: pointer
  }

  .resource-info-detail .info .info-desc .info-desc-text .action span[data-v-dc683b5e] {
      color: #0548ff;
      font-size: 18px;
      line-height: 24px;
      margin-right: 8px;
      transition: color .2s
  }

  .resource-info-detail .info .info-desc .info-desc-text .action .iconfont[data-v-dc683b5e] {
      font-size: 12px
  }

  .resource-info-detail .info .info-desc .info-desc-radios[data-v-dc683b5e] {
      height: 46px;
      background: hsla(0,0%,100%,.16);
      border-radius: 23px;
      padding: 4px;
      box-sizing: border-box;
      display: inline-block;
      position: relative
  }

  .resource-info-detail .info .info-desc .info-desc-radios[data-v-dc683b5e] .indicator {
      height: 38px;
      border-radius: 23px;
      background: #fff;
      position: absolute;
      top: 3.5px
  }

  .resource-info-detail .info .info-desc .info-desc-radios.small .info-desc-radios-item[data-v-dc683b5e] {
      width: 96px
  }

  .resource-info-detail .info .info-desc .info-desc-radios.normal .info-desc-radios-item[data-v-dc683b5e] {
      width: 158px
  }

  .resource-info-detail .info .info-desc .info-desc-radios.toutiao[data-v-dc683b5e] {
      background: rgba(51,51,51,.1)
  }

  .resource-info-detail .info .info-desc .info-desc-radios.toutiao .active[data-v-dc683b5e] {
      color: #ff5251
  }

  .resource-info-detail .info .info-desc .info-desc-radios.douyin .active[data-v-dc683b5e] {
      color: #333
  }

  .resource-info-detail .info .info-desc .info-desc-radios.xigua[data-v-dc683b5e] {
      background: rgba(51,51,51,.1)
  }

  .resource-info-detail .info .info-desc .info-desc-radios.xigua .active[data-v-dc683b5e] {
      color: #fa5b7d
  }

  .resource-info-detail .info .info-desc .info-desc-radios.dongchedi[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.faceu[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.qingyan[data-v-dc683b5e] {
      background: rgba(51,51,51,.1);
      color: #333!important
  }

  .resource-info-detail .info .info-desc .info-desc-radios.dongchedi[data-v-dc683b5e] .indicator,.resource-info-detail .info .info-desc .info-desc-radios.faceu[data-v-dc683b5e] .indicator,.resource-info-detail .info .info-desc .info-desc-radios.qingyan[data-v-dc683b5e] .indicator {
      background: #333
  }

  .resource-info-detail .info .info-desc .info-desc-radios.dongchedi .active[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.faceu .active[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.qingyan .active[data-v-dc683b5e] {
      color: #fff!important
  }

  .resource-info-detail .info .info-desc .info-desc-radios.dongchedi .info-desc-radios-item[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.faceu .info-desc-radios-item[data-v-dc683b5e],.resource-info-detail .info .info-desc .info-desc-radios.qingyan .info-desc-radios-item[data-v-dc683b5e] {
      color: #333
  }

  .resource-info-detail .info .info-desc .info-desc-radios .info-desc-radios-item[data-v-dc683b5e] {
      height: 38px;
      line-height: 38px;
      text-align: center;
      display: inline-block;
      cursor: pointer;
      color: #fff;
      position: relative;
      z-index: 30
  }

  .resource-info-detail .info .info-desc .info-desc-radios .info-desc-radios-item.active[data-v-dc683b5e] {
      font-weight: 700;
      transition: all .2s
  }

  .phone-content-deco-wrapper[data-v-dc683b5e] {
      width: 335px;
      height: 638.8px;
      position: absolute;
      left: -7.8px;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center
  }

  .phone-content-deco-wrapper.positioned[data-v-dc683b5e] {
      align-items: flex-start
  }

  .phone-content-deco-wrapper .phone-content-deco[data-v-dc683b5e] {
      border-radius: 9px;
      width: 335px;
      height: auto;
      opacity: 1
  }

  .phone-content-deco-wrapper .phone-content-deco.video-deco[data-v-dc683b5e] {
      transition: all .3s
  }

  .phone-content-deco-wrapper .phone-content-deco.img-deco[data-v-dc683b5e] {
      transition: all .4s cubic-bezier(.23,1.7,.79,.9)
  }

  .phone-content-deco-wrapper .phone-content-deco.changing[data-v-dc683b5e] {
      width: 227px;
      opacity: 0
  }

  @-webkit-keyframes fade-data-v-dc683b5e {
      0% {
          opacity: 0
      }

      to {
          opacity: 1
      }
  }

  @keyframes fade-data-v-dc683b5e {
      0% {
          opacity: 0
      }

      to {
          opacity: 1
      }
  }

  .resource-info .header-info[data-v-0748bb76] {
      position: relative;
      height: 520px;
      width: 100%;
      background: linear-gradient(90deg,#16161c 50%,#0c1219);
      overflow: hidden
  }

  .resource-info .header-info .header-info-bg[data-v-0748bb76] {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      height: 100%
  }

  .resource-info .header-info .header-info-info[data-v-0748bb76] {
      color: #fff;
      padding-top: 159px;
      position: relative
  }

  .resource-info .header-info .header-info-info .title[data-v-0748bb76] {
      font-family: HYYakuHei;
      font-size: 40px;
      line-height: 40px;
      margin-bottom: 32px
  }

  .resource-info .header-info .header-info-info .desc[data-v-0748bb76] {
      margin-bottom: 40px;
      font-size: 16px;
      line-height: 30px;
      width: 520px
  }

  .resource-info .header-info .header-info-info .glowbtn[data-v-0748bb76] {
      height: 40px
  }
  .el-input-group__append, .el-input-group__prepend {
      background: none !important;
  }
  .input-login .el-input__inner {
    color: #fff !important;
  }
</style>
